import { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, TextField, MenuItem, Button, Paper} from "@mui/material";
import Header from "../Components/layout/Header";
import { API } from "../conf";
import { Context } from "../App";
import success_gif from '../asset/pictures/Successfully Done.gif';
import { useNavigate } from "react-router-dom";

export default function Cloture() {
    const navigate = useNavigate()
    const { updateConnect, exercice } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"]
    const [loading, setLoad] = useState(true)
    const [result, setResult] = useState()
    const [uncloture_months, setUncloture_months] = useState([])
    const [month, setMonth] = useState('')
    const [dons, setDons] = useState([])
    const [versements, setVersements] = useState([])
    const [depenses, setDepenses] = useState([])

    const eglise = useMemo(()=>{
        if (organisation && organisation.type==='église') {
            return organisation
        } else if (egliseId!=='') {
            return eglises.find(el=> el._id === egliseId)
        } else return
    }, [eglises, egliseId, organisation])

    function handleSubmit() {
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise.number}/cloture/${month}?exercice=${exercice}`), {
            method:'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setResult(<img src={success_gif} alt="succès" loading="eager" width={500} height={500}/>)
                    setTimeout(() => {
                        navigate("/")
                    }, 3000);
                }
            }
        })       
    }

    function reset() {
        setUncloture_months([])
        setMonth('')
        setDons([])
        setVersements([])
        setDepenses([])
    }

    function get_uncloture(month) {
        setLoad(true)
        fetch(API.concat(`/eglises/${eglise.number}/cloture/${exercice}/${month+1}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const {dons, depenses, versements} = await response.json()
                    setDons(dons)
                    setDepenses(depenses)
                    setVersements(versements)
                }setLoad(false)
            }
        })
    }

    useEffect(()=>{
        if(eglise&&eglise.number) {
            const query = new URLSearchParams({exercice: exercice, eglise: eglise.number, isMonth: true})
            fetch(API.concat(`/clotures/by?${query.toString()}`),{
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const clotures = await response.json()

                        const allMonths = Array.from({ length: exercice===new Date().getFullYear() ? new Date().getMonth() + 1 : 12 }, (_, i) => i)
                        const cloturedMonths = clotures.map(cloture=> new Date(cloture.date).getMonth())
                        const uncloturedMonths = allMonths.filter(month=> !cloturedMonths.includes(month))
                        setUncloture_months(uncloturedMonths)

                        // if ((oldestUncloture && new Date(oldestUncloture) instanceof Date && !isNaN(new Date(oldestUncloture)))||clotures.length>0) {
                        //     const currentDate = new Date()
                        //     const oldestDate = oldestUncloture && new Date(oldestUncloture) instanceof Date && !isNaN(new Date(oldestUncloture)) ? new Date(oldestUncloture) : clotures.reduce((min, currentMonth) => (new Date(currentMonth.date) < new Date(min.date)) ? new Date(currentMonth.date) : new Date(min.date))
                        //     if (currentDate.getFullYear()>oldestDate.getFullYear()) {
                        //         const months = [
                        //             ...Array.from({ length: 11-oldestDate.getMonth()+1 }, (_, i) => i+oldestDate.getMonth()), 
                        //             ...Array.from({ length: currentDate.getMonth() + 1 }, (_, i) => i)
                        //         ].filter(month=>!clotures.some(cloture=>new Date(cloture.date).getMonth()===month))
                        //         setUncloture_months(months)
                        //     } else {
                        //         const months = Array.from({ length: currentDate.getMonth() - oldestDate.getMonth()+1 }, (_, i) => i+oldestDate.getMonth())
                        //         .filter(month=>!clotures.some(cloture=>new Date(cloture.date).getMonth()===month))
                        //         setUncloture_months(months)
                        //     }
                        // }else {
                        //     const currentMonth = new Date().getMonth(); // 0 indexed (janvier = 0)
                        //     const months = Array.from({ length: new Date().getFullYear()===exercice ? currentMonth + 1 : 12 }, (_, i) => i)
                        //     setUncloture_months(months)
                        // }
                    } setLoad(false)
                }
            })
        }
    }, [eglise])

    useEffect(()=>{
        if (organisation&&organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[]) 
    
    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Clôture</Typography>
            {organisation&&organisation.type==='fédération'&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)reset(); return e.target.value})}>
                {eglises.map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}
            {eglise&&<Box sx={{paddingX:'20px', marginTop:'30px'}}>
                <TextField
                id="outlined-select-currency"
                select
                sx={{minWidth:'300px', marginBottom:'25px'}}
                required
                label="Mois a clôturer"
                value={month}
                onChange={(e)=> {
                    setMonth(Number(e.target.value))
                    get_uncloture(Number(e.target.value))
                }}
                >
                {uncloture_months.length<=0 ? <MenuItem value="">Aucun mois disponible</MenuItem>
                :uncloture_months.map((month, index) => (
                    <MenuItem key={index} value={month}>
                        <Typography sx={{}}>{months[month]}</Typography> 
                    </MenuItem>
                ))}
                </TextField>
                
                {month !=='' && <div style={{display:'flex', justifyContent:'center'}}><Paper sx={{ height:'100%', paddingX:'25px', paddingY:'30px'}}>
                    <Typography variant="h5" sx={{marginBottom:'15px'}}><span style={{fontWeight:'bold'}}>{dons.length}</span> don{dons.length>1 && 's'} d'une recette local totale de 
                    <span style={{fontWeight:'bold'}}> {(dons.reduce((accumulator, currentValue) => {
                            const toadd = currentValue.offrande_spe_eglise.reduce((off_accumulator, off_currentValue)=>{return off_accumulator + off_currentValue.montant}, 0)
                            return accumulator + currentValue.offrande_globale*0.6 + (toadd?? 0)}, 0)).toFixed(2)}€</span>
                    </Typography>
                    <Typography variant="h5" sx={{marginBottom:'15px'}}><span style={{fontWeight:'bold'}}>{versements.length}</span> versement{versements.length>1 && 's'}</Typography>
                    <Typography variant="h5" sx={{marginBottom:'15px'}}><span style={{fontWeight:'bold'}}>{depenses.length}</span> dépense{depenses.length>1 && 's'} d'un total de
                        <span style={{fontWeight:'bold'}}> {(depenses.reduce((accumulator, currentValue) => {return accumulator + currentValue.montant}, 0)).toFixed(2)}€</span>
                    </Typography>
                </Paper></div>}
            </Box>}

            <Box rowGap={1} sx={{display:'flex', flexDirection:'column', marginTop:'20px'}}>
                {new Date().getMonth() === month && new Date().getFullYear() === exercice ? <Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', marginTop:versements.some(verse=>verse.is_error)?0:'20px', alignSelf:'flex-end', marginRight:'15px'}}>
                    Vous ne pouvez pas clôturer un mois en cours.
                </Typography>
                :<>
                {versements.some(verse=>verse.is_error)&&<Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', alignSelf:'flex-end', marginRight:'15px'}}>
                    Vous avez un ou plusieurs versements en erreur.<br/>Veuillez contacter votre Administrateur.
                </Typography>}
                {depenses.some(dep=>dep.to_controlle)&&<Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', alignSelf:'flex-end', marginRight:'15px'}}>
                    Vous avez une ou plusieurs dépenses en attente de validation.<br/>Veuillez vous rendre dans le journal des dépenses afin de les valider.
                </Typography>}
                {month!=="" && dons.some(don=> !don.is_verse && new Date(don.date).getMonth()===month) && 
                <Typography variant="subtitle1" textAlign='center' sx={{color: 'carmine.main', marginTop:versements.some(verse=>verse.is_error)?0:'20px', alignSelf:'flex-end', marginRight:'15px'}}>
                    <span style={{fontWeight:'bold'}}>Attention!</span><br/>Il vous reste des dons à verser ou des versements en attente de validation pour le mois de {months[month]}.<br/> Veuillez régulariser votre situation afin de clôturer le mois.
                </Typography>}
                </>
                }
                {month !== '' && <Button 
                    variant="contained" 
                    sx={{ alignSelf:'flex-end', marginRight:'30px' }}
                    disabled={month===""|| dons.some(don=> !don.is_verse) || depenses.some(dep=> dep.to_controlle) || (new Date().getMonth() === month && new Date().getFullYear() === exercice) || versements.some(verse=>verse.is_error) }
                    onClick={handleSubmit}>Cloturer le mois</Button>
                }
            </Box>

            <Backdrop open={loading}>{result??<CircularProgress color="inherit" />}</Backdrop>
        </div>
    )
}